import React from 'react';
const LogoDesktop = ({ alternate }: { alternate: boolean }) => {
  if (alternate) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#006bff" viewBox="0 0 1173.98 350.42">
        <title>Zillow Rental Manager</title>
        <path
          className="a"
          d="M784.94,87.22h36l10.42,34.07c3.48,11.28,6.51,21.87,9.33,32.63h.44c3-10.53,6-21.74,9.48-32.63l10.92-34.07h26.56l10.74,34.07c3.63,11.67,6.32,21.84,9.29,32.63h.44c2.82-10.79,5.89-21.22,9.33-32.63l10.42-34.07h33.42l-36.15,112.6H892.66l-8.95-28.28c-3.45-11.08-6.73-22.36-9.55-32.79h-.44c-2.82,10.43-6.1,21.28-9.73,32.6l-9.14,28.47H821.37Z"
        />
        <rect className="a" x="542.87" y="27.74" width="36.39" height="172.08" />
        <rect className="a" x="606.22" y="27.74" width="36.39" height="172.08" />
        <path
          className="a"
          d="M660.63,143.91c0-34.2,27.59-59.55,61.35-59.55,33.42,0,61,25.35,61,59.55s-27.59,59.66-61,59.66c-33.76,0-61.35-25.35-61.35-59.66m87.45,0c0-16.76-12-28.16-26.1-28.16-14.49,0-26.44,11.4-26.44,28.16s12,28.16,26.44,28.16c14.15,0,26.1-11.3,26.1-28.16"
        />
        <polygon
          className="a"
          points="332.35 43.67 332.35 76.84 396.67 76.85 396.9 77.3 330.4 190.28 330.4 199.82 455.68 199.82 455.68 166.71 386.09 166.71 385.86 166.25 452.31 53.28 452.26 53.28 452.26 43.67 332.35 43.67"
        />
        <path
          className="a"
          d="M497.06,30.83a20.44,20.44,0,1,1-20.72,20.44,20.65,20.65,0,0,1,20.72-20.44m-18.19,56.4h36.38v112.6H478.87Z"
        />
        <path
          className="a"
          d="M191,85.36c1.43-.42,2.13.07,3,1,5.18,5.38,21.91,24.18,26.49,29.32a1.71,1.71,0,0,1-.3,2.56c-31.16,26.42-65.53,63.39-84.46,89.63-.41.56-.05.58.22.45,34.51-16.52,116.42-44.05,152.44-51.93V115.8L144.35,1.93,0,115.8v56.35C44,143.76,144.9,98.85,191,85.36Z"
        />
        <path
          className="a"
          d="M81.79,285.75a2.39,2.39,0,0,1-3.15-.34L50.47,254.48c-.78-.84-.87-1.29,0-2.74,19.53-31.29,60-80.4,86.23-101.53.46-.38.32-.71-.23-.51C108.4,160.17,28.07,198.6,0,216.23V318.68H288.41V208.3C248.38,217,133.69,256.3,81.79,285.75Z"
        />
        <path
          className="b"
          d="M985.61,71.16a5.24,5.24,0,0,0-5.4-5.51h-5.79V81.37H977V76.66h2.53l2.88,4.73h2.94l-3.1-5.09A5.29,5.29,0,0,0,985.61,71.16Zm-5.55,3.19h-3V68h3a3.19,3.19,0,0,1,0,6.37Z"
        />
        <path
          className="b"
          d="M979.43,60.19A13.59,13.59,0,1,0,993,73.78h0A13.61,13.61,0,0,0,979.43,60.19Zm0,24.56a11,11,0,1,1,11-11h0A11,11,0,0,1,979.43,84.75Z"
        />
        <path
          className="b"
          d="M1125.84,292.86h-46.23c.26,11.53,7.39,18.26,18.78,18.26,7.9,0,13.34-3.11,15.8-8.8h11.27c-2.08,11-13.08,18.64-27.07,18.64-18.39,0-29.91-12.17-29.91-31.46,0-18.91,11.65-31.34,29.39-31.34,16.84,0,28.23,11.65,28.23,28.1A60.59,60.59,0,0,1,1125.84,292.86Zm-10.74-8.67c0-10.49-6.48-17-17.35-17s-17.62,6.87-18.14,17Z"
        />
        <path
          className="b"
          d="M863.44,259h11.28v11c3.24-7.65,10.51-12.58,20.88-12.58,14.66,0,22.18,8.56,22.18,24.52v36.83H906.63V286.91c0-13.36-4.41-19.71-15-19.71-11.15,0-16.86,7.91-16.86,20v31.65H863.44Z"
        />
        <path
          className="b"
          d="M787.45,289c0-17.69,11.31-31.61,29.91-31.61,9.5,0,17.3,4.82,21.08,12.23V259h11.18v60H838.44V308.42c-3.78,7.41-12.36,12.1-21.34,12.1C798,320.52,787.45,306.73,787.45,289Zm51.5,0c0-11.58-7.15-21.46-20.29-21.46-12.35,0-20,9.1-20,21.46s7.68,21.33,20,21.33C831.8,310.37,839,300.62,839,289Z"
        />
        <path
          className="b"
          d="M926.06,289c0-17.69,11.32-31.61,29.92-31.61,9.49,0,17.3,4.82,21.07,12.23V259h11.19v60H977.05V308.42c-3.77,7.41-12.36,12.1-21.33,12.1C936.6,320.52,926.06,306.73,926.06,289Zm51.51,0c0-11.58-7.15-21.46-20.29-21.46-12.36,0-20,9.1-20,21.46s7.67,21.33,20,21.33C970.42,310.37,977.57,300.62,977.57,289Z"
        />
        <path
          className="b"
          d="M691.3,235.75h12.32l29.85,66.41,29.86-66.41h12.18v83H764.33V260.05L738,318.74h-9l-26.48-59.08v59.08H691.3Z"
        />
        <path
          className="b"
          d="M1059.16,259v58.76c0,11.52-3.66,20.15-10.46,25.39-5.11,3.79-12.18,5.63-20.81,5.63-8.25,0-16-2-21.46-5.89a20.3,20.3,0,0,1-8.9-16h11.91c.78,7.07,6.8,12.3,18.32,12.3,13.08,0,20.15-6.28,20.15-20.67v-9.82c-3.8,7.59-12.69,12.17-21.46,12.17-18.45,0-29.84-13.87-29.84-31.67s12.17-31.8,30.1-31.8c9.29,0,17.4,4.58,21.2,12.31V259Zm-10.73,30.23c0-11.91-7.72-21.59-20.41-21.59-12,0-20.15,9.16-20.15,21.59s8.24,21.46,20.15,21.46C1040.71,310.69,1048.43,301,1048.43,289.23Z"
        />
        <path
          className="b"
          d="M1137.88,258.9h11.4v13.21c2.36-10.22,10.09-14.68,17.69-14.68a22.52,22.52,0,0,1,5.5.53v10.48a26.84,26.84,0,0,0-5.64-.39c-11.92,0-17.55,10.87-17.55,24.36v26.33h-11.4Z"
        />
        <path
          className="b"
          d="M454.82,292.86H408.59c.26,11.53,7.38,18.26,18.78,18.26,7.9,0,13.34-3.11,15.8-8.8h11.26c-2.07,11-13.07,18.64-27.06,18.64-18.39,0-29.91-12.17-29.91-31.46,0-18.91,11.65-31.34,29.39-31.34,16.84,0,28.23,11.65,28.23,28.1A60.59,60.59,0,0,1,454.82,292.86Zm-10.75-8.67c0-10.49-6.47-17-17.35-17s-17.61,6.87-18.13,17Z"
        />
        <path
          className="b"
          d="M465.6,259h11.28v11c3.25-7.65,10.51-12.58,20.89-12.58,14.65,0,22.17,8.56,22.17,24.52v36.83H508.79V286.91c0-13.36-4.41-19.71-15.05-19.71-11.15,0-16.86,7.91-16.86,20v31.65H465.6Z"
        />
        <path
          className="b"
          d="M564.42,308.49v10a50.58,50.58,0,0,1-10.1.91c-7,0-18.26-1.3-18.26-20.59V268.35H525.31v-9.46h10.75V240h11.27v18.9h15v9.46h-15v28c0,11.39,3.88,12.95,9.58,12.95A43,43,0,0,0,564.42,308.49Z"
        />
        <path
          className="b"
          d="M570.4,289c0-17.69,11.31-31.61,29.91-31.61,9.5,0,17.3,4.82,21.07,12.23V259h11.19v60H621.38V308.42c-3.77,7.41-12.35,12.1-21.33,12.1C580.93,320.52,570.4,306.73,570.4,289Zm51.5,0c0-11.58-7.15-21.46-20.29-21.46-12.35,0-20,9.1-20,21.46s7.68,21.33,20,21.33C614.75,310.37,621.9,300.62,621.9,289Z"
        />
        <path className="b" d="M646.27,235.75h11.27V318.9H646.27Z" />
        <path
          className="b"
          d="M374.39,290.62c11-3.76,18.62-13.78,18.62-26.59,0-16.5-12.47-28.32-28.5-28.32h-33.4V319h11.66V292.37h19L378.33,319h13.48l-17.45-28.26Zm-31.62-44.3h20.15c10.06,0,18.44,6.83,18.44,17.71s-8.38,17.6-18.44,17.6H342.77Z"
        />
      </svg>
    );
  } else {
    return (
      <svg
        id="Logo"
        fill="#006aff"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1911 400"
        aria-labelledby="zillowLogo"
        role="img"
      >
        <title id="zillowLogo">Zillow Logo</title>
        <path d="M1460.41,148.57h77.77l22.54,73.68c7.52,24.41,20.09,70.24,20.09,70.24a.6.6,0,0,0,1.13,0s13-46.68,20.42-70.24L1626,148.57h57.44l23.23,73.68c7.85,25.25,20,70.22,20,70.22a.6.6,0,0,0,1.15,0s12.63-45.54,20.07-70.22l22.55-73.68h72.28l-78.19,243.55h-71.13L1674,331c-7.45-24-20.55-70.57-20.55-70.57a.6.6,0,0,0-1.15,0s-13.1,45.68-20.95,70.15l-19.77,61.59h-72.41Z" />
        <rect x="936.81" y="19.92" width="78.71" height="372.21" />
        <rect x="1073.84" y="19.91" width="78.72" height="372.21" />
        <path d="M1380.68,271.18c0-36.24-25.85-60.9-56.46-60.9-31.34,0-57.19,24.66-57.19,60.9,0,36.48,25.85,60.9,57.19,60.9,30.61,0,56.46-24.42,56.46-60.9m-189.16,0c0-74,59.68-128.81,132.7-128.81,72.29,0,132,54.84,132,128.81,0,74.21-59.68,129.05-132,129.05-73,0-132.7-54.84-132.7-129" />
        <path d="M481.46,54.36v71.76H620.58c.57,0,.78.52.49,1L481.4,364.48c-3.36,6.17-4.16,7.49-4.16,13.65v14h271V320.49H597.69a.62.62,0,0,1-.5-1L738.48,79c1.12-2.34,2.3-4,2.3-9.64l.05-15Z" />
        <path d="M798.37,148.58h78.7V392.13h-78.7Zm39.35-122c24.54,0,44.82,19.8,44.82,44.19S862.26,115,837.72,115s-44.81-19.8-44.81-44.2S813.18,26.6,837.72,26.6" />
        <path d="M242.17,106.29c1.8-.44,2.63.2,3.71,1.41,6.16,6.93,26,31.1,31.4,37.71a2.12,2.12,0,0,1-.49,3.16c-40,31.22-84.49,75.38-109.3,107-.53.67-.09.72.26.57,43.21-18.6,144.67-48.27,190.44-56.59V141.64L179.28.23.05,141.64v63.29C55.61,171.91,184,120.8,242.17,106.29Z" />
        <path d="M96.63,349.5a3,3,0,0,1-3.88-.57L59.34,309.14c-.93-1.08-1-1.65.18-3.41C85.32,267.88,138,209,171.59,184.05c.6-.44.44-.86-.26-.63-35,11.44-134.47,54.17-171.28,75V393.6H358.18V263.5C309.27,271.81,163.08,315.27,96.63,349.5Z" />
        <path d="M1895.2,113.87c0-7-4.86-11.91-11.67-11.91H1871v34h5.59V125.77h5.49L1888.3,136h6.36l-6.7-11C1892.33,123.34,1895.2,119.16,1895.2,113.87Zm-12,6.9h-6.61V107h6.61c3.7,0,6.42,2.92,6.42,6.91S1886.89,120.77,1883.19,120.77Z" />
        <path d="M1881.84,90.16a29.38,29.38,0,1,0,29.38,29.37A29.41,29.41,0,0,0,1881.84,90.16Zm0,53.11a23.74,23.74,0,1,1,23.74-23.74A23.77,23.77,0,0,1,1881.84,143.27Z" />
      </svg>
    );
  }
};

export default LogoDesktop;
